import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=2663db45&"
import script from "./VoucherList.vue?vue&type=script&lang=js&"
export * from "./VoucherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports